import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { I18nProvider } from "./i18n";
import { tg } from "./telegram";
import "./styles.css";

const t = tg();
if (t) {
  t.ready();
  t.expand();
}

// Telegram WebView caches the bundle aggressively. nginx sends no-store on
// index.html, but as a fallback we periodically compare the running bundle
// hash with the one in a fresh index.html and force-reload on mismatch.
function currentBundleHash(): string | null {
  const scripts = document.querySelectorAll<HTMLScriptElement>(
    'script[src*="/assets/index-"][src$=".js"]',
  );
  for (const s of Array.from(scripts)) {
    const m = s.src.match(/\/assets\/index-([A-Za-z0-9_-]+)\.js/);
    if (m) return m[1];
  }
  return null;
}

async function checkForUpdate(): Promise<void> {
  try {
    const res = await fetch("/index.html?_=" + Date.now(), { cache: "no-store" });
    if (!res.ok) return;
    const html = await res.text();
    const m = html.match(/\/assets\/index-([A-Za-z0-9_-]+)\.js/);
    if (!m) return;
    const remote = m[1];
    const local = currentBundleHash();
    if (local && local !== remote) {
      window.location.replace(window.location.pathname + "?_v=" + remote);
    }
  } catch {
    // keep current build
  }
}

checkForUpdate();
setInterval(checkForUpdate, 5 * 60 * 1000);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </React.StrictMode>,
);
